import * as yup from 'yup'
import dayjs from 'dayjs'

export const schema = yup.object().shape({
  fulfillmentCenterId: yup.number(),
  modelId: yup.string().optional().matches(/^([0-9]+)?$/, 'O modelo deve ser numérico').trim(),
  code: yup.string().trim(),
  barcode: yup.string().trim(),
  description: yup.string().trim(),
  sourceSystem: yup.string().trim(),
  startDate: yup.date()
    .required('Data início é obrigatório')
    .transform((curr, orig) => (orig === '' ? null : curr)),
  endDate: yup.date()
    .required('Data fim é obrigatório')
    .transform((curr, orig) => (orig === '' ? null : curr))
    .min(
      yup.ref('startDate'),
      'A data final não pode ser menor do que a data inicial',
    )
    .test('rangeLimit', 'O intervalo entre Data Início e Data Fim deve ser no máximo de 60 dias', function (value) {
      const startDate = dayjs(this?.parent?.startDate)
      const endDate = dayjs(value)

      return (endDate.diff(startDate, 'day') <= 60)
    }),
})
